import {TrophyOutlined} from "@ant-design/icons"
import {
    Home,
    Circle,
    Folder,
    Users,
    BarChart2,
    ShoppingCart,
    Activity,
    List,
    Plus,
    MessageCircle,
    User, DollarSign, Lock, Award, ShoppingBag
} from 'react-feather'

export default [
    {
        id: 'feed',
        title: 'menu_feed',
        action: 'read',
        icon: <MessageCircle size={12} />,
        navLink: '/feed'
    },
    {
        id: 'coupon_add',
        action: 'read',
        title: 'menu_coupon_add',
        icon: <Plus size={12} />,
        navLink: '/coupon/add'
    },
    {
        id: 'tipsters',
        action: 'read',
        title: 'menu_tipsters',
        icon: <Users size={12} />,
        navLink: '/tipsters'
    },
    // {
    //     id: 'chat',
    //     action: 'read',
    //     title: 'menu_chat',
    //     icon: <MessageCircle size={12} />,
    //     navLink: '/chat'
    // },
    {
        id: 'couponGenerator',
        action: 'read',
        title: 'menu_coupon_generator',
        icon: <ShoppingBag size={12} />,
        navLink: '/couponGenerator'
    }
]
